export default __webpack_public_path__ + "images/deployed-code-update-purple.svg";